import React from 'react';
import PropTypes from 'prop-types';
import ReviewHeaderUserBlurb from './ReviewHeaderUserBlurb';
import ReviewHeaderTitleBlurb from './ReviewHeaderTitleBlurb';
import CustomShowMoreText from '../UI/CustomShowMoreText/CustomShowMoreText';

export default class TitleReview extends React.Component {
	static propTypes = {
		review: PropTypes.object,
		children: PropTypes.element,
	};

	renderHeader() {
		const { review, source, communityId } = this.props;
		return (
			<div
				style={{
					flexGrow: '1',
					marginLeft: '10px',
				}}>
				{source !== 'titleDetail' ? (
					source !== 'user' ? (
						<ReviewHeaderUserBlurb review={review} />
					) : (
						<ReviewHeaderTitleBlurb
							review={review}
							communityId={communityId}
						/>
					)
				) : (
					<React.Fragment />
				)}
				{review.text && review.text !== '' ? (
					<React.Fragment></React.Fragment>
				) : (
					<div>{this.renderCreated(review)}</div>
				)}
			</div>
		);
	}

	renderReviewText() {
		const { review } = this.props;
		return (
			<div
				style={{
					fontSize: '14px',
				}}>
				<CustomShowMoreText text={review.text} lines={3} />
			</div>
		);
	}

	getReviewAndFooterText = review => {
		return (
			<React.Fragment>
				{review.text && review.text !== '' && this.renderReviewText()}
				{review.text &&
					review.text !== '' &&
					this.renderCreated(review)}
			</React.Fragment>
		);
	};

	renderCreated(review) {
		const rating = review.rating ? review.rating : review.overallAssessment;
		const createdDate = review.createdDate
			? review.createdDate
			: review.updatedDate;
		return (
			<div
				style={{
					fontStyle: 'italic',
					fontSize: '10px',
				}}>
				{review.text && review.text !== ''
					? 'Rated ' + rating + ' out of 10, Written'
					: 'Rated ' + rating + ' out of 10'}{' '}
				on{' '}
				{new Date(createdDate).toLocaleDateString('en-US', {
					weekday: 'long',
					year: 'numeric',
					month: 'long',
					day: 'numeric',
				})}
			</div>
		);
	}

	render() {
		const { review } = this.props;

		return (
			<div className="round-background">
				<div style={{ padding: '0.5rem 10px 0.5rem 10px' }}>
					<div style={{ display: 'flex' }}>
						<div style={{ marginTop: '3px' }}>
							{this.props.children}
						</div>
						{this.renderHeader()}
					</div>
					{this.getReviewAndFooterText(review)}
				</div>
			</div>
		);
	}
}
